import React, {useContext,useState,useEffect,forwardRef} from 'react';
import {MyContext} from '../../login/MyContext';
import {Link} from 'react-router-dom';


import { AddBox, ArrowDownward } from "@material-ui/icons";
import MaterialTable from "material-table";
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import axios from 'axios';
import Login from '../../login/Login';



//import Row from "./Row";

const multiregistros = {
  idUsuario:"",
  cargo: "",
  valor: "",
  v1: "",
  v2: "",
  v3: "",
  v4: "",
  v5: "",
  v6: "",
  v7: "",
  v8: "",
  v9: "",
  v10: "",
  f1: "",
  f2: "",
  f3: "",
  f4: "",
  f5: "",
  f6: "",
  f7: "",
  f8: "",
  f9: "",
  f10: "",
};

function Calcular_costos () {
  const {rootState,logoutUser} = useContext(MyContext);
  const {isAuth,theUser,showLogin} = rootState;

 const {toggleNav,registerUser} = useContext(MyContext);
  
  const baseUrlAd="https://aliraweb.com/apiAlira2/empresas_usuarios/perfiles.php"
  const [data, setData]=useState([]);
  const [modalInsertar, setModalInsertar]=useState(false);
  const [modalEditar, setModalEditar]=useState(false);
  const [modalEliminar, setModalEliminar]=useState(false);
  const [frameworkSeleccionado, setFrameworkSeleccionado]=useState({
    id:'',
    idUsuario:'',
    cargo:'',   
    valor:'', 
    v1:'',
    v2:'',
    v3:'',
    v4:'',
    v5:'',
    v6:'',
    v7:'',
    v8:'',
    v9:'',
    v10:'',
    f1:'',
    f2:'',
    f3:'',
    f4:'',
    f5:'',
    f6:'',
    f7:'',
    f8:'',
    f9:'',
    f10:'',
  });

 

  //multiregistros
 const [rows, setRows] = useState([multiregistros]);
  
    const handleOnChange = (index, name, value) => {
      const copyRows = [...rows];
      copyRows[index] = {
        ...copyRows[index],
        [name]: value
      };
      setRows(copyRows);
    };
  
    const handleOnAdd = () => {
      setRows(rows.concat(multiregistros));
    };
  
    const handleOnRemove = index => {
      const copyRows = [...rows];
      copyRows.splice(index, 1);
      setRows(copyRows);
    };



  
  const [idArticulos, setIdArticulos] = useState(-1);

  const handlerCargarArticulos = function (e){
  const opcion = e.target.value;
  console.log(opcion);
  
  setIdArticulos(opcion);

  }

  
  const handleChange=e=>{
    const {name, value}=e.target;
    setFrameworkSeleccionado((prevState)=>({
      ...prevState,
      [name]: value
    }))
   console.log(frameworkSeleccionado);
  }

  const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
  }

  const peticionGet =async() =>{
   // await axios.get(baseUrlAd)
   await axios.get(`https://aliraweb.com/apiAlira2/empresas_usuarios/perfiles.php?idUsuario=${global.idprincipal}`)
   //await axios.get(`https://aliraweb.com/apiAlira2/empresas_usuarios/mis_cargos.php?usuarioE=${global.idprincipal}`)
    .then(response=>{
     setData(response.data);
    }).catch(error=>{
      console.log(error);
    })

  }



  const [cargo, setCountry]= useState([]);

  useEffect( ()=>{

    const interval = setInterval(() => {
    const getcountry= async ()=>{
   const req= await fetch(`https://aliraweb.com/apiAlira2/empresas_usuarios/cargar_cargos.php?usuarioE=${global.idprincipal}`)
  // const req= await fetch("https://parqueoenvia.co/apiParqueoenvia/zonas/country.php");
      const getres= await req.json();
      console.log(getres);
      setCountry(await getres);
  
    }
    getcountry();

}, 2000);

return () => setInterval(interval);
  
  
   },[]);


   
 /*  const interval = setInterval(() => {
      
    peticionGet();
   
    
  }, 2000);

return () => setInterval(interval);

},[])*/

  

   const peticionPut = async() =>{
    var f = new FormData();
    f.append("cargo", frameworkSeleccionado.cargo);
    f.append("valor", frameworkSeleccionado.valor);
    f.append("v1", frameworkSeleccionado.v1);
    f.append("v2", frameworkSeleccionado.v2);
    f.append("v3", frameworkSeleccionado.v3);
    f.append("v4", frameworkSeleccionado.v4);
    f.append("v5", frameworkSeleccionado.v5);
    f.append("v6", frameworkSeleccionado.v6);
    f.append("v7", frameworkSeleccionado.v7);
    f.append("v8", frameworkSeleccionado.v8);
    f.append("v9", frameworkSeleccionado.v9);
    f.append("v10", frameworkSeleccionado.v10);
    f.append("f1", frameworkSeleccionado.f1);
    f.append("f2", frameworkSeleccionado.f2);
    f.append("f3", frameworkSeleccionado.f3);
    f.append("f4", frameworkSeleccionado.f4);
    f.append("f5", frameworkSeleccionado.f5);
    f.append("f6", frameworkSeleccionado.f6);
    f.append("f7", frameworkSeleccionado.f7);
    f.append("f8", frameworkSeleccionado.f8);
    f.append("f9", frameworkSeleccionado.f9);
    f.append("f10", frameworkSeleccionado.f10);
    f.append("METHOD", "PUT_CARGO");
    await axios.post(baseUrlAd,f, {params: {id: frameworkSeleccionado.id}})
    .then(response=>{
     var dataNueva = data;
     dataNueva.map(framework=>{
       if(framework.id===frameworkSeleccionado.id){
         framework.cargo= frameworkSeleccionado.cargo;
         framework.valor= frameworkSeleccionado.valor;
         framework.v1= frameworkSeleccionado.v1;
         framework.v2= frameworkSeleccionado.v2;
         framework.v3= frameworkSeleccionado.v3;
         framework.v4= frameworkSeleccionado.v4;
         framework.v5= frameworkSeleccionado.v5;
         framework.v6= frameworkSeleccionado.v6;
         framework.v7= frameworkSeleccionado.v7;
         framework.v8= frameworkSeleccionado.v8;
         framework.v9= frameworkSeleccionado.v9;
         framework.v10= frameworkSeleccionado.v10;
         framework.f1= frameworkSeleccionado.f1;
         framework.f2= frameworkSeleccionado.f2;
         framework.f3= frameworkSeleccionado.f3;
         framework.f4= frameworkSeleccionado.f4;
         framework.f5= frameworkSeleccionado.f5;
         framework.f6= frameworkSeleccionado.f6;
         framework.f7= frameworkSeleccionado.f7;
         framework.f8= frameworkSeleccionado.f8;
         framework.f9= frameworkSeleccionado.f9;
         framework.f10= frameworkSeleccionado.f10;
       }
     });
     setData(dataNueva);
     abrirCerrarModalEditar();
    }).catch(error=>{
      console.log(error);
    })

  }


  const peticionPost = async() =>{
    var f = new FormData();
    f.append("idUsuario", theUser.id);
    f.append("cargo", frameworkSeleccionado.cargo);
    f.append("valor", frameworkSeleccionado.valor);
    f.append("v1", frameworkSeleccionado.v1);
    f.append("v2", frameworkSeleccionado.v2);
    f.append("v3", frameworkSeleccionado.v3);
    f.append("v4", frameworkSeleccionado.v4);
    f.append("v5", frameworkSeleccionado.v5);
    f.append("v6", frameworkSeleccionado.v6);
    f.append("v7", frameworkSeleccionado.v7);
    f.append("v8", frameworkSeleccionado.v8);
    f.append("v9", frameworkSeleccionado.v9);
    f.append("v10", frameworkSeleccionado.v10);
    f.append("f1", frameworkSeleccionado.f1);
    f.append("f2", frameworkSeleccionado.f2);
    f.append("f3", frameworkSeleccionado.f3);
    f.append("f4", frameworkSeleccionado.f4);
    f.append("f5", frameworkSeleccionado.f5);
    f.append("f6", frameworkSeleccionado.f6);
    f.append("f7", frameworkSeleccionado.f7);
    f.append("f8", frameworkSeleccionado.f8);
    f.append("f9", frameworkSeleccionado.f9);
    f.append("f10", frameworkSeleccionado.f10);
    f.append("METHOD", "POST");
    await axios.post(baseUrlAd,f)
    .then(response=>{
     setData(data.concat(response.data));
     abrirCerrarModalInsertar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }



  const peticionDelete = async() =>{
    var f = new FormData();
    f.append("METHOD", "DELETE_administrador");
    await axios.post(baseUrlAd,f, {params: {id: frameworkSeleccionado.id}})
    .then(response=>{
     setData(data.filter(framework=>framework.id!==frameworkSeleccionado.id));
     abrirCerrarModalEliminar();
    }).catch(error=>{
      console.log(error);
    })

  }



  const seleccionarFramework=(framework, caso)=>{
    setFrameworkSeleccionado(framework);
    (caso==="Editar")?
    abrirCerrarModalEditar():
    abrirCerrarModalEliminar()


  }

  useEffect(()=>{
    

    const interval = setInterval(() => {
      
       peticionGet();
      
       
     }, 2000);
 
   return () => setInterval(interval);
 
   },[])

  

  
  const columnas =[
    {
      title:"ID",
      field: "id",
      
    },
    
    {
      title:"C.EMPRESA",
      field: "cargo"
    },

    {
      title:'SUELDO BASE ($)',
      //format: (field) => field.toFixed(2),
      format: (field) => field.toLocaleString(),
      field: 'valor',
      
      

      //align: 'right',
      //minWidth: 170,
      
     // format: (value) => value.toLocaleString('en-US'),
     
    },

      

    
    
  ];

//formatear valores en pesos
  const nf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 2,
    //roundingIncrement: 5
  });

    if(isAuth && theUser.tipo_usuario =="empresa")
    {
  return (
 
<div id="content" class="app-content">

<ol class="breadcrumb float-xl-end">

<div class="theme-panel">
<a href="javascript:;" data-toggle="theme-panel-expand" class="theme-collapse-btn"><i class="fa fa-cog"></i></a>
<div class="theme-panel-content" data-scrollbar="true" data-height="100%">
<h5>Color Empresarial</h5>

<div class="theme-list">
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-red" data-theme-class="theme-red" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Red">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-pink" data-theme-class="theme-pink" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Pink">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-orange" data-theme-class="theme-orange" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Orange">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-yellow" data-theme-class="theme-yellow" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Yellow">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-lime" data-theme-class="theme-lime" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Lime">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-green" data-theme-class="theme-green" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Green">&nbsp;</a></div>
<div class="theme-list-item active"><a href="javascript:;" class="theme-list-link bg-teal" data-theme-class="" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Default">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-cyan" data-theme-class="theme-cyan" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Cyan">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-blue" data-theme-class="theme-blue" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Blue">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-purple" data-theme-class="theme-purple" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Purple">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-indigo" data-theme-class="theme-indigo" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Indigo">&nbsp;</a></div>
<div class="theme-list-item"><a href="javascript:;" class="theme-list-link bg-black" data-theme-class="theme-gray-600" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Black">&nbsp;</a></div>
</div>

<div class="theme-panel-divider"></div>
<div class="row mt-10px">
<div class="col-8 control-label text-dark fw-bold">
<div>DÍA / NOCHE </div>
<div class="lh-14">

</div>
</div>
<div class="col-4 d-flex">
<div class="form-check form-switch ms-auto mb-0">
<input type="checkbox" class="form-check-input" name="app-theme-dark-mode" id="appThemeDarkMode" value="1" />
<label class="form-check-label" for="appThemeDarkMode">&nbsp;</label>
</div>
</div>
</div>
<div class="theme-panel-divider"></div>

{/*<div class="row mt-10px align-items-center">
<div class="col-8 control-label text-dark fw-bold">Header Fixed</div>
<div class="col-4 d-flex">
<div class="form-check form-switch ms-auto mb-0">
<input type="checkbox" class="form-check-input" name="app-header-fixed" id="appHeaderFixed" value="1" checked />
<label class="form-check-label" for="appHeaderFixed">&nbsp;</label>
</div>
</div>
  </div> */}
<div class="row mt-10px align-items-center">
<div class="col-8 control-label text-dark fw-bold">Color barra superior</div>
<div class="col-4 d-flex">
<div class="form-check form-switch ms-auto mb-0">
<input type="checkbox" class="form-check-input" name="app-header-inverse" id="appHeaderInverse" value="1" />
<label class="form-check-label" for="appHeaderInverse">&nbsp;</label>
</div>
</div>
</div>
{/*<div class="row mt-10px align-items-center">
<div class="col-8 control-label text-dark fw-bold">Espacio menux</div>
<div class="col-4 d-flex">
<div class="form-check form-switch ms-auto mb-0">
<input type="checkbox" class="form-check-input" name="app-sidebar-fixed" id="appSidebarFixed" value="1" checked />
<label class="form-check-label" for="appSidebarFixed">&nbsp;</label>
</div>
</div>
  </div> */}
<div class="row mt-10px align-items-center">
<div class="col-8 control-label text-dark fw-bold">Espacio menu</div>
<div class="col-4 d-flex">
<div class="form-check form-switch ms-auto mb-0">
<input type="checkbox" class="form-check-input" name="app-sidebar-grid" id="appSidebarGrid" value="1" />
<label class="form-check-label" for="appSidebarGrid">&nbsp;</label>
</div>
</div>
</div>
<div class="row mt-10px align-items-center">
<div class="col-md-8 control-label text-dark fw-bold">Color menu</div>
<div class="col-md-4 d-flex">
<div class="form-check form-switch ms-auto mb-0">
<input type="checkbox" class="form-check-input" name="app-gradient-enabled" id="appGradientEnabled" value="1" />
<label class="form-check-label" for="appGradientEnabled">&nbsp;</label>
</div>
</div>
</div>


</div>
</div>



</ol>


<div class="row">




</div>



<div class="row">

<div class="col-xl-12">


<div class="panel panel-inverse" data-sortable-id="form-stuff-1" data-init="true">

<div class="panel-heading ui-sortable-handle">
<h4 class="panel-title">{theUser.name}</h4>
<div class="panel-heading-btn">
<a href="javascript:;" class="btn btn-xs btn-icon btn-default" data-toggle="panel-expand" title="Expandir"><i class="fa fa-expand"></i></a>

</div>
</div>


<div class="panel-body">



<MaterialTable

     
columns={columnas}
data={data}
title= {<><i class="fas fa-calculator fa-2x"></i></> }
backIconButtonText='Página anterior'
pagination
fixedHeader


actions={[

   {
        icon : 'calculate',
        tooltip: 'Calcular',
        onClick: (event, framework)=>seleccionarFramework(framework, "Editar")
      },
    
 /* {
   icon : 'delete',
   tooltip: 'Eliminar',
    onClick: (event, framework)=>seleccionarFramework(framework, "Eliminar")
 }*/
]}
/*options={{
  actionsColumnIndex: -1
}}*/
options={{
    
    actionsColumnIndex: -1,
 actionsCellStyle: {
   // backgroundColor: "#ffccdd",
   // color: "#FF00dd"
  
 },

 headerStyle: { backgroundColor: "#348fe2",  headerStyle: { position: 'sticky'}, boxShadow:"0 0  0 2px rgb(255,255,255)", color: "white", padding: "0.75rem 0.9375rem", fontSize: 10}
}}
localization={{
    header:{
    actions: 'ACCIONES'
    
  },
  body:{ 
    emptyDataSourceMessage:'No hay registros que mostrar',
    
   },

 

   pagination: {
     firstAriaLabel: 'Primera página',
     firstTooltip: 'Primera página',
     labelDisplayedRows: '{from}-{to} de {count}',
     labelRowsPerPage: 'Filas por página:',
     labelRowsSelect: 'filas',
     lastAriaLabel: 'Ultima página',
     lastTooltip: 'Ultima página',
     nextAriaLabel: 'Pagina siguiente',
     nextTooltip: 'Pagina siguiente',
     previousAriaLabel: 'Pagina anterior',
     previousTooltip: 'Pagina anterior',
   },
   toolbar: {
     searchPlaceholder: 'Buscar',
     searchTooltip: 'Buscar',
     showColumnsAriaLabel: 'Mostrar columnas',
     showColumnsTitle: 'Mostrar columnas',
   },

   
}}



/>


<form >
    
</form>
</div>






</div>

</div>




</div>


<Modal isOpen={modalEliminar}>
 <ModalBody>
   ¿Estas seguro que desea eliminar el cargo relacionado con {frameworkSeleccionado && frameworkSeleccionado.cargo}?
   </ModalBody>
   <ModalFooter>
     <button className="btn btn-danger"
     onClick={()=>peticionDelete()}
     >
       SI
     </button>
     <button
       className="btn btn-secondary"
       onClick={()=>abrirCerrarModalEliminar()}
       >
         NO
     </button>

   </ModalFooter>
 

</Modal>





<Modal isOpen={modalEditar}>
 <ModalHeader  style={{backgroundColor:"#348fe2",color:"white"}} ><i class="fas fa-calculator"></i> <font Size="2">CALCULAR COSTOS</font></ModalHeader>
 <ModalBody>
 <div className="form-group">
   <div className="row">


   <div className="col-7">
            <label>Cargo </label>
            <input name="cargo" className="form-control" type="text" placeholder="Ingrese salario" 
                  onChange={handleChange} value={frameworkSeleccionado && frameworkSeleccionado.cargo} readOnly />
           <br/>
                </div>

 

            <div class="col-md-5">
             
            <label>Salario Base </label>
<div class="input-group">

<div class="input-group-text">$</div>
<input name="valor" className="form-control" type="text" placeholder="Ingrese salario" 
                  onChange={handleChange} value={nf.format(frameworkSeleccionado.valor )} readOnly/>

</div>

</div>




          <center>  <hr/></center>

          <div class="col-md-6">
            <label>30% Factor Prestacional </label>
<div class="input-group">

<div class="input-group-text">$</div>
<input  className="form-control" type="text" readOnly
                  onChange={handleChange} value={nf.format(global.factor)}  />

</div>
<br/>
</div>


<div class="col-md-6">
            <label>Salario Integral </label>
<div class="input-group">

<div class="input-group-text">$</div>
<input  className="form-control" type="text" readOnly
                  onChange={handleChange} value={nf.format(global.integral)} />

</div>
<br/>
</div>
       
     

    

<center>  <label>------------------------------ SEGURIDAD SOCIAL ---------------------------------</label></center>


<br/>
<br/>
<div class="col-md-4">
            <label>EPS (8.5%) </label>
<div class="input-group">


<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>

<div class="col-md-4">
            <label>Pensión (12%) </label>
<div class="input-group">


<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>

<div class="col-md-4">
            <label>ARL </label>
            <div class="form-group">
             
              <select class="form-select form-control-clicked" id="v1_disponible" name="v1_disponible" aria-label="Default select example">
                <option value="0" selected="">Seleccionar</option>
                <option value="0.005">Riego l &gt; 0.005%</option>
                <option value="0.01">Riego ll &gt; 0.01%</option>
                <option value="0.024">Riego lll &gt; 0.024%</option>
                <option value="0.044">Riego lV &gt; 0.044%</option>
                <option value="0.07">Riego V &gt; 0.07%</option>
              </select>
            </div>
</div>


<div class="col-md-4">
            <label>ARL </label>
<div class="input-group">


<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>

<center>  <label>------------------------------ PRESTACIONES SOCIALES ---------------------------------</label></center>



<br/>
<br/>
       
<div class="col-md-4">
            <label>Prima </label>
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>   


<div class="col-md-4">
            <label>Cesantias </label>
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>  


<div class="col-md-4">
            <label>Int. Cesantias </label>
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>  


<div class="col-md-4">
            <label>Vacaciones </label>
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>  


<div class="col-md-4">
            <label>Sena (2%) &nbsp; </label>
            <input type="checkbox" /><div style={{marginTop:"-20px", marginLeft:"90px"}}><h6> Calcular</h6> </div>
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<label>Aportes parafiscales</label>
<br/>
</div>  



<div class="col-md-4">
  
            <label>ICBF (3%) &nbsp; </label>
            <input type="checkbox" /><div style={{marginTop:"-20px", marginLeft:"90px"}}><h6> Calcular</h6> </div>
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>  

<br/>
<div class="col-md-4">
<br/>
            <label>Caja de compensación &nbsp; </label>
           
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  />

</div>
<br/>
</div>  


<div class="col-md-4">
<br/>
            <label><b>Total Mensual </b>&nbsp; </label>
           
<div class="input-group">
<input  className="form-control" type="number" readOnly
                  onChange={handleChange}  style={{borderColor:"orange"}}/>

</div>
<br/>
</div>  









  <div style={{display:"none"}}>
  <input type="text" className="form-control"  name="idUsuario" onChange={handleChange} 
  value={theUser.id}  />
  <input type="text" value= {global.factor=frameworkSeleccionado.valor * 30 / 100}   />
  <input type="text" value= {global.integral=Number(global.factor) + Number(frameworkSeleccionado.valor)}    />
  </div>


  
 

  </div>

   
   </div>
 </ModalBody>
 <ModalFooter>
   
   <button className="btn btn-success w-100 btn-lg" onClick={()=>abrirCerrarModalEditar()}><i class="fa-solid fa-circle-xmark"></i> ACEPTAR</button>
 </ModalFooter>
</Modal>


<Modal isOpen={modalInsertar}>
<ModalHeader  style={{backgroundColor:"#348fe2",color:"white"}} ><i class="fas fa-hands-helping"></i> <font Size="2">PERFIL Y MANUAL DE FUNCIONES</font></ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">



  <div className="col-7">
   
                 <label>Cargo:</label>
              <select name="cargo" className="form-select" onChange={handleChange}>
                   <option>--Seleccionar cargo--</option>
                   {
                     cargo.map( (getcon)=>(
                      
                   <option key={getcon.id} value={getcon.cargo }> {getcon.cargo}</option>
                
                     ))
                    
                }

                              
                 </select>
              
               

               
            </div> 
            <div class="col-md-5">
            <label>Salario Base </label>
<div class="input-group">

<div class="input-group-text">$</div>
<input name="valor" className="form-control" type="number" placeholder="Ingrese salario" 
                  onChange={handleChange}  />

</div>
<br/>
</div>

          <center>  <label>------------------------------ PERFIL CARGO ---------------------------------</label></center>
        

            <div class="accordion" id="accordion">
            <br/>
<div class="accordion-item border-0">
<div class="accordion-header" id="headingOne">
<button class="accordion-button bg-gray-300 text-black px-3 py-10px pointer-cursor collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false">
<i class="fa fa-circle fa-fw text-blue me-2 fs-8px"></i>  Lista 1
</button>
</div>
<div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordion">
<div class="accordion-body bg-gray-100 text-black">

<div>
    <label><b>Perfil 1</b></label>
                  <textarea rows={5} name="v1" className="form-control" type="text" placeholder="" 
                  onChange={handleChange}  />
                  <br/>
                  </div>


                  <div>
                  <label><b>Perfil 2</b></label>
                  <textarea rows={5} name="v2" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


                  <div>
                  <label><b>Perfil 3</b></label>
                  <textarea rows={5} name="v3" className="form-control" type="text" placeholder="" 
                  onChange={handleChange}  />
                  <br/>
                  </div>


                  <div>
                  <label><b>Perfil 4</b></label>
                  <textarea rows={5} name="v4" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>

                  <div>
                  <label><b>Perfil 5</b></label>
                  <textarea rows={5} name="v5" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>

                  <div>

        
                  </div>


</div>
</div>
</div>
<div class="accordion-item border-0">
<div class="accordion-header" id="headingTwo">
<button class="accordion-button bg-gray-300 text-black px-3 pt-10px pb-10px pointer-cursor collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false">
<i class="fa fa-circle fa-fw text-indigo me-2 fs-8px"></i> Lista 2
</button>
</div>
<div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordion" >
<div class="accordion-body bg-gray-100 text-black">

<div>
<label><b>Perfil 6</b></label>
                  <textarea rows={5} name="v6" className="form-control" type="text" placeholder=""
                  onChange={handleChange}  />
                  <br/>
                  </div>


                  <div>
                  <label><b>Perfil 7</b></label>
                  <textarea rows={5} name="v7" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


                  <div>
                  <label><b>Perfil 8</b></label>
                  <textarea rows={5} name="v8" className="form-control" type="text" placeholder=""
                  onChange={handleChange}  />
                  <br/>
                  </div>


                  <div>
                  <label><b>Perfil 9</b></label>
                  <textarea rows={5} name="v9" className="form-control" type="text" placeholder="" 
                  onChange={handleChange}  />
                  <br/>
                  </div>

                  <div>
                  <label><b>Perfil 10</b></label>
                  <textarea rows={5} name="v10" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


</div>
</div>
</div>





<br/>


</div>

<center>  <label>------------------------------ MANUAL DE FUNCIONES ---------------------------------</label></center>
        
<div class="accordion" id="accordion">
            <br/>
<div class="accordion-item border-0">
<div class="accordion-header" id="headingThree">
<button class="accordion-button bg-gray-300 text-black px-3 pt-10px pb-10px pointer-cursor collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false">
<i class="fa fa-circle fa-fw text-teal me-2 fs-8px"></i> Lista 1
</button>
</div>
<div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordion">
<div class="accordion-body bg-gray-100 text-black">

<div>
<label><b>Funciones 1</b></label>
                  <textarea rows={5} name="f1" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


                  <div>
                  <label><b>Funciones 2</b></label>
                  <textarea rows={5} name="f2" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


                  <div>
                  <label><b>Funciones 3</b></label>
                  <textarea rows={5} name="f3" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


                  <div>
                  <label><b>Funciones 4</b></label>
                  <textarea rows={5} name="f4" className="form-control" type="text" placeholder=""
                  onChange={handleChange}  />
                  <br/>
                  </div>

                  <div>
                  <label><b>Funciones 5</b></label>
                  <textarea rows={5} name="f5" className="form-control" type="text" placeholder="" 
                  onChange={handleChange}/>
                  <br/>
                  </div>

</div>
</div>
</div>
<div class="accordion-item border-0">
<div class="accordion-header" id="headingFour">
<button class="accordion-button bg-gray-300 text-black px-3 pt-10px pb-10px pointer-cursor collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false">
<i class="fa fa-circle fa-fw text-info me-2 fs-8px"></i> Lista 2
</button>
</div>
<div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordion">
<div class="accordion-body bg-gray-100 text-black">

<div>
<label><b>Funciones 6</b></label>
                  <textarea rows={5} name="f6" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


                  <div>
                  <label><b>Funciones 7</b></label>
                  <textarea rows={5} name="f7" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>


                  <div>
                  <label><b>Funciones 8</b></label>
                  <textarea rows={5} name="f8" className="form-control" type="text" placeholder="" 
                  onChange={handleChange}/>
                  <br/>
                  </div>


                  <div>
                  <label><b>Funciones 9</b></label>
                  <textarea rows={5} name="f9" className="form-control" type="text" placeholder="" 
                  onChange={handleChange} />
                  <br/>
                  </div>

                  <div>
                  <label><b>Funciones 10</b></label>
                  <textarea rows={5} name="f10" className="form-control" type="text" placeholder=""
                  onChange={handleChange}  />
                  <br/>
                  </div>
</div>
</div>
</div>
</div>


  <div style={{display:"none"}}>
  <input type="text" className="form-control"  name="idUsuario" onChange={handleChange} 
  value={theUser.id}  />
  </div>


  
 

  </div>

   
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPost()}><i class="fa-solid fa-pen-to-square"></i> Guardar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar()}><i class="fa-solid fa-circle-xmark"></i> Cancelar</button>
 </ModalFooter>
</Modal>



</div>
   
  )
}

else if(showLogin){
    return"";
}

}

export default Calcular_costos
